export default function TemplateGrid() {
  const templates = [
    {
      type: 'JUST LISTED',
      price: '$725,000',
      details: '3 Bed • 2 Bath • 2,100 Sq Ft',
      address: '123 Maple Street • Houston, TX',
      bgColor: '#F8F4EF',
      textColor: '#1A1208',
      priceColor: '#E8603C',
      caption: 'New listing alert! 🏡 This stunning 3-bed home just hit the market in one of Houston\'s most desirable neighborhoods. #HoustonRealEstate #JustListed #DreamHome',
      likes: '234',
      hasPhoto: true
    },
    {
      type: 'JUST SOLD',
      price: '$825,000',
      details: '4 Bed • 3 Bath • 2,500 Sq Ft',
      address: '789 Pine Avenue • Houston, TX',
      bgColor: 'linear-gradient(135deg, #E8603C 0%, #D94E2A 100%)',
      textColor: '#FFFFFF',
      priceColor: '#FFFFFF',
      caption: 'Another happy family in their dream home! 🎉 Congratulations to my clients on closing this beautiful property. #Sold #HoustonHomes #RealEstateSuccess',
      likes: '267',
      hasPhoto: false
    },
    {
      type: 'BUYER TIP',
      headline: 'Get pre-approved before touring homes.',
      body: 'Knowing your budget saves time and strengthens your offer.',
      bgColor: '#F8F4EF',
      textColor: '#1A1208',
      caption: 'Get pre-approved before touring homes. Here\'s why it matters... 💡 #BuyerTips #FirstTimeHomeBuyer #RealEstateAdvice',
      likes: '189',
      hasPhoto: false
    },
    {
      type: 'SELLER TIP',
      headline: 'Stage your home to maximize buyer appeal.',
      body: 'First impressions matter. A well-staged home sells faster and for more money.',
      bgColor: '#1A1208',
      textColor: '#FFFFFF',
      caption: '3 simple staging tips that help homes sell faster... 🏡 #SellerTips #HomeSelling #RealEstateExpert',
      likes: '221',
      hasPhoto: false
    },
    {
      type: 'MARKET UPDATE',
      stats: [
        { label: 'Median Price', value: '↑ 4.2%', trend: 'up' },
        { label: 'Inventory', value: '↓ Low', trend: 'down' },
        { label: 'Avg Days on Market', value: '↓ 28', trend: 'down' }
      ],
      bgColor: '#F8F4EF',
      textColor: '#1A1208',
      caption: 'Houston market snapshot for this month 📊 What these numbers mean for buyers and sellers... #MarketUpdate #HoustonRealEstate #RealEstateData',
      likes: '312',
      hasPhoto: false
    },
    {
      type: 'CLIENT TESTIMONIAL',
      stars: 5,
      quote: 'The whole process felt effortless. I felt like I had an advocate, not just an agent.',
      author: 'Sarah M., First-Time Buyer',
      bgColor: '#F8F4EF',
      textColor: '#1A1208',
      caption: 'Nothing makes me happier than reviews like this 💙 Thank you Sarah for trusting me with your home buying journey! #ClientLove #Testimonial #HappyClients',
      likes: '198',
      hasPhoto: false
    }
  ];

  return (
    <section className="py-20 px-6" style={{ background: '#F0EAE2' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="text-[#E8603C] uppercase tracking-wider text-sm font-semibold mb-3">
            Preview
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            See How Your Feed Will Look
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            These Instagram-style mockups show exactly how your content will appear on a mobile feed. Each template is fully editable in Canva.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {templates.map((template, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden border border-black/6 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10),0_30px_60px_rgba(0,0,0,0.14)] transition-all duration-200 hover:-translate-y-1"
              style={{
                boxShadow: '0 6px 12px rgba(0,0,0,0.06), 0 18px 40px rgba(0,0,0,0.10)'
              }}
            >
              {/* Instagram Header */}
              <div className="flex items-center gap-3 p-4 border-b border-gray-100">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#E8603C] to-orange-400"></div>
                <div className="flex-1">
                  <div className="font-semibold text-sm text-gray-900">yourname.realty</div>
                  <div className="text-xs text-gray-500">📍 Houston, Texas</div>
                </div>
                <i className="ri-more-fill text-gray-400"></i>
              </div>

              {/* Post Content */}
              <div 
                className="aspect-square flex flex-col justify-center p-8"
                style={{ 
                  background: template.bgColor,
                  color: template.textColor
                }}
              >
                {/* Just Listed/Sold Posts */}
                {(template.type === 'JUST LISTED' || template.type === 'JUST SOLD') && (
                  <>
                    <div className="text-xs font-bold tracking-wider mb-4 opacity-60">
                      {template.type}
                    </div>
                    <div 
                      className="text-4xl font-bold mb-4"
                      style={{ color: template.priceColor }}
                    >
                      {template.price}
                    </div>
                    <div className="text-sm font-medium mb-2">
                      {template.details}
                    </div>
                    <div className="text-sm opacity-70 mb-6">
                      {template.address}
                    </div>
                    {template.hasPhoto && (
                      <div className="border-2 border-dashed border-gray-300 rounded-lg h-32 flex items-center justify-center text-xs text-gray-400">
                        Photo Area
                      </div>
                    )}
                  </>
                )}

                {/* Buyer/Seller Tip Posts */}
                {(template.type === 'BUYER TIP' || template.type === 'SELLER TIP') && (
                  <>
                    <div className="text-xs font-bold tracking-wider mb-6 opacity-60">
                      {template.type}
                    </div>
                    <h3 className="text-2xl font-bold mb-4 leading-tight">
                      {template.headline}
                    </h3>
                    <p className="text-base opacity-80 leading-relaxed">
                      {template.body}
                    </p>
                  </>
                )}

                {/* Market Update Post */}
                {template.type === 'MARKET UPDATE' && (
                  <>
                    <div className="text-xs font-bold tracking-wider mb-6 opacity-60">
                      {template.type}
                    </div>
                    <div className="space-y-4">
                      {template.stats?.map((stat, idx) => (
                        <div key={idx} className="flex justify-between items-center py-3 border-b border-gray-300">
                          <span className="text-sm font-medium">{stat.label}</span>
                          <span className="text-xl font-bold">{stat.value}</span>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {/* Testimonial Post */}
                {template.type === 'CLIENT TESTIMONIAL' && (
                  <>
                    <div className="flex gap-1 mb-6 justify-center">
                      {[...Array(template.stars)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-2xl text-[#E8603C]"></i>
                      ))}
                    </div>
                    <div className="text-xs font-bold tracking-wider mb-4 opacity-60 text-center">
                      {template.type}
                    </div>
                    <p className="text-lg italic leading-relaxed mb-4 text-center">
                      "{template.quote}"
                    </p>
                    <p className="text-sm opacity-70 text-center">
                      — {template.author}
                    </p>
                  </>
                )}
              </div>

              {/* Brokerage Footer */}
              <div className="bg-gray-50 px-4 py-2 border-t border-gray-100">
                <div className="text-xs text-gray-500 text-center">
                  Your Brokerage Name
                </div>
              </div>

              {/* Instagram Footer */}
              <div className="p-4 border-t border-gray-100">
                <div className="flex items-center gap-4 mb-3">
                  <i className="ri-heart-line text-2xl text-gray-700 cursor-pointer hover:text-red-500 transition-colors"></i>
                  <i className="ri-chat-3-line text-2xl text-gray-700 cursor-pointer hover:text-gray-900 transition-colors"></i>
                  <i className="ri-share-line text-2xl text-gray-700 cursor-pointer hover:text-gray-900 transition-colors"></i>
                  <i className="ri-bookmark-line text-2xl text-gray-700 ml-auto cursor-pointer hover:text-gray-900 transition-colors"></i>
                </div>
                <div className="font-semibold text-sm text-gray-900 mb-2">{template.likes} likes</div>
                <p className="text-sm text-gray-700">
                  <span className="font-semibold">yourname.realty</span> {template.caption.split('#')[0]}
                  <span className="text-[#E8603C]">
                    {template.caption.match(/#\w+/g)?.join(' ')}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}